import type {
  GetStaticPaths,
  GetStaticProps,
  GetStaticPropsContext,
  InferGetStaticPropsType,
} from "next";
import { useRouter } from "next/router";
import CalculatorLayout from "@/components/calculators/CalculatorLayout";
import { CALCULATORS, getCalculator } from "@/lib/calculators/data";

export const getStaticPaths = (async () => ({
  paths: CALCULATORS.map((c) => ({ params: { slug: c.slug } })),
  fallback: "blocking",
})) satisfies GetStaticPaths;

export const getStaticProps = (async (context: GetStaticPropsContext) => {
  const slug = context.params?.slug;
  if (typeof slug !== "string" || !getCalculator(slug)) {
    return { notFound: true };
  }
  return { props: { slug } };
}) satisfies GetStaticProps<{ slug: string }>;

export default function CalculatorPage({
  slug: initialSlug,
}: InferGetStaticPropsType<typeof getStaticProps>) {
  const router = useRouter();
  const slug = typeof router.query.slug === "string" ? router.query.slug : initialSlug;
  const calculator = getCalculator(slug);

  if (router.isFallback || !calculator) return null;

  return <CalculatorLayout calculator={calculator} />;
}
